import styled from "styled-components";
import { largeComponentHeight } from "common/const/const";
import React, { useState } from "react";

import {
  inputBorderStyle,
  InputWrapper,
} from "common/components/Wrapper/InputBase";
import { useValidCheckSingle } from "common/hooks/validCheck";

export const StyledInputBase = styled.input`
  ${inputBorderStyle}
  align-items: center;
  width: 100%;
  height: ${largeComponentHeight};
  padding: 0;
  padding-left: ${(props) =>
    props.iconPosition === "left" ? "3.5rem" : "1.25rem"};
  padding-right: ${(props) =>
    props.iconPosition === "right" ? "3.5rem" : "1.25rem"};

  font-family: var(--font-family);
  font-size: var(--fontSize-14);

  box-sizing: border-box;
`;

export const TextInput = ({
  //InputWrapper
  label,
  caption,
  icon,
  rules,

  //TextInput
  name,
  type = "text",
  pattern,
  placeholder,
  disabled,
  readOnly,
  defaultValue,
  onChange,
  forceError, // 외부에서 강제 에러 주기
  ...rest
}) => {
  const [isComposing, setIsComposing] = useState(false);

  const { inputProps, error, onValueChange } = useValidCheckSingle({
    name: name,
    rules: rules,
    defaultValue: defaultValue,
  });

  const hasError = forceError || error; // 👈 외부에서 오버라이드 가능

  let displayValue = inputProps.value ?? "";
  if (disabled) {
    displayValue = "";
  }

  return (
    <InputWrapper
      label={label}
      caption={caption}
      icon={icon}
      rules={rules}
      error={hasError}>
      <StyledInputBase
        {...inputProps}
        type={type}
        name={name}
        onCompositionStart={() => setIsComposing(true)}
        onCompositionEnd={() => setIsComposing(false)}
        onChange={(e) => {
          const val = e.target.value;
          if (isComposing || !pattern || pattern.test(val)) {
            onValueChange(val);
            onChange?.(val);
          }
        }}
        placeholder={
          readOnly ? undefined : disabled ? inputProps.value : placeholder
        }
        value={displayValue}
        disabled={disabled}
        readOnly={readOnly}
        iconPosition={icon?.position}
        $error={!!hasError} // 👈 여기 반영
        pattern={pattern?.source}
        {...rest}
      />
    </InputWrapper>
  );
};
